<template>
  <div>
    <div class="title">
        <span style="cursor: pointer" @click="$router.go(-1)">数据分析</span>
        > <span>物流公司</span>
    </div>
    <div>
      <div  class="main">
        <!-- 搜索框渲染 -->
        <div class="demo-form-title">
            <img :src="ImgIcon" alt="" style="margin-right:6px"> 
            <div class="demo-form-fist">物流公司占比</div>
            <div class="demo-form-fu">门店物流公司发货占比数</div>
        </div>
          <div style="margin-left:50px">
            <Todayapick :SubmitBleen="SubmitBleen" @GetArrayList="GetArrayList"></Todayapick>
        </div>
      </div>
      <div class="concet">
          <!-- 饼状图渲染 -->
          <div id="EChart" style="flex:2; height:500px"></div>
          <ul style="flex:1;height:160px;overflow-y: auto;" >
            <li v-for="(item,index) in ExpressDelivery" :key="index" class="Commodity_box">
              <div v-show="show" class="Commodity" :style='{background:item.color}'></div> 
              <div class="CommodityRbox">
                  <span class="CommodityName">{{item.name}}</span>
                  <span class="CommodityVal">{{item.num}}</span>
              </div>
            </li>
          </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Todayapick from "@/components/AnalysisPicker/TimePicker.vue"
let echarts = require("echarts");
export default {
  components:{Todayapick},
  data(){
    return{
      ImgIcon:require("@/assets/icon/icon_fenle.png"),//顶部图标
      SubmitBleen:false,//子组件是否展示搜索
      pickerOptions: { //限制选择当前时间之后的方法
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;  //如果没有后面的-8.64e6就是不可以选择今天的 
        }
      },
      ruleForm:{ //搜索框所需绑定的值
        time:"",
        StartTime:"",
        EndTime:"",
      },
      ExpressDelivery:[],
      show:false,
      shopIDList:[],//商户ID的数组
    }
  },
  created(){
   
  },
  mounted(){
      let shopIDList=JSON.parse(localStorage.getItem("shop")).shop
      shopIDList.forEach(item=>{
        this.shopIDList.push(item.shop_id)
      })
      this.DefaultTime()
      this.GetCompaniesRatioArray(this.ruleForm.StartTime,this.ruleForm.EndTime)
  },
  computed:{

  },
  methods:{
    ...mapActions({
        CompaniesRatio: "dataAnalysis/CompaniesRatio",//vuex中请求的接口物流公司发货占比
    }),
    DefaultTime(){ //默认查询当前时间
      var endData=new Date()
      var month = parseInt(endData.getMonth() + 1);
      var day = endData.getDate();
      var hous=endData.getHours()
      var minu=endData.getSeconds()
      var fend=endData.getMinutes()
        if (month < 10) {
          month = "0" + month;
        }
        if (day < 10) {
          day = "0" + day;
        }
        if (hous < 10) {
          hous = "0" + hous;
        }
        if (fend < 10) {
          fend = "0" + fend;
        }
        this.ruleForm.StartTime=endData.getFullYear() + "-" + month + "-" + day+" "+"00:00:00"
        this.ruleForm.EndTime=endData.getFullYear() + "-" + month + "-" + day+" "+hous+":"+fend+":"+minu
    },
    getRenderer() { //商品销售饼状图渲染事件
      let data=[]
      if(this.ExpressDelivery.length>0){
        for (var i =0;i<this.ExpressDelivery.length;i++){
          data.push({
              value:this.ExpressDelivery[i].num,
              name:this.ExpressDelivery[i].name
          })
        }
      }
      let EChart = echarts.init(document.getElementById("EChart"));
      let config = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          series: [
            {
              type: 'pie',
              radius:  ['45%', '70%'],
              center: ['60%', '50%'],
              selectedMode: 'single',
              data:data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
      };
      // 设置参数
      EChart.setOption(config);
      let brr=EChart.getModel().option.color
      let brrindex=-1
      for (let index = 0; index < this.ExpressDelivery.length; index++) {
        if(brrindex>=brr.length-1){
          brrindex=0
          this.ExpressDelivery[index].color=brr[brrindex];
        }else{
          brrindex++
          this.ExpressDelivery[index].color=brr[brrindex];
        }
      }
      this.show=true
    },
    GetCompaniesRatioArray(state,end){ //vuex中请求的接口物流公司发货占比
      let params={
        "shopIdList":this.shopIDList,
        "timeBegin":state,
        "timeEnd":end
      }
      this.CompaniesRatio(params).then(res=>{
        if(res.code===10000){
          this.ExpressDelivery=res.data
          this.getRenderer()//商品销售饼状图渲染执行

        }
      })
    },
    GetArrayList(event){ //搜索框子组件触发的方法 获取所需值
      // this.ruleForm.StartTime=event.StartTime
      // this.ruleForm.EndTime=event.EndTime
      this.GetCompaniesRatioArray(event.StartTime,event.EndTime)
    },
  }
}
</script>
<style lang="scss" scoped>
ul,li{ 
  padding:0;
  margin:0;
  list-style:none;
}
.main {
  min-width: 1200px;
  margin: 20px 20px 5px 20px ;
  background: #fff;
  padding:20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-form-item{
  margin: 0;
}
.title {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    width: 100%;
    background: #fff;
    font-size: 18px;
    color: #333;
    width: 100%;
    padding: 15px 32px;
}
.demo-form-title{
  display: flex;
  .demo-form-fist{
    font-size: 16px;
    color: #333;
  }
  .demo-form-fu{
    margin-left: 19px;
    font-size: 14px;
    color: #999;
  }
}
.container {
	width: 1400px;
	height: 400px;
	background-color:#ccffcc;
}
 
/*设置宽度,轨道颜色*/
::-webkit-scrollbar {
	width:6px;
	height: 6px;
	background: #ccc;   /*可以设置轨道颜色*/
	padding-right: 2px;
	border-radius: 10px;
}
 
/*滚动条*/
::-webkit-scrollbar-thumb {
	background: #999;
	border-radius: 10px;
}
.concet{
  // border: 1px solid #ccc;
  min-width: 1200px;
  margin:5px 20px 20px 20px ;
  height: 100%;
  padding: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #fff;
  .Commodity_box{
    width: 128px;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    .Commodity{
      width: 12px;
      height: 12px;
      border-radius: 50%;
    }
    .CommodityRbox{
      flex:1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .CommodityName{
        font-size: 14px;
        margin-left: 5px;
        color: #333;
      }
      .CommodityVal{
        color: #2448FF;
      }
    }
  }
  
  
}
</style>